import React from "react";

export const QuestionFormField = ({
  id,
  name,
  type,
  value,
  onChange,
  onBlur,
  className,
  placeholder,
  required,
  label,
  options,
  min,
  max,
}) => {
  return (
    <div className="relative w-full group">
      {type === "select" ? (
        <select
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          className={className}
          required={required}
        >
          {options?.map((option, i) => (
            <option key={i} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          id={id}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          className={className}
          placeholder={placeholder}
          min={min}
          max={max}
          required={required}
        />
      )}
      <label
        htmlFor={id}
        className="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 origin-[0] peer-focus:start-0 peer-focus:text-orange-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
      >
        {label}
      </label>
    </div>
  );
};